function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDashboard = function SvgDashboard(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M685.7 969.3H314.3c-11.4 0-20.6-9.2-20.6-20.6v-41.3c0-11.4 9.2-20.6 20.6-20.6h371.5c11.4 0 20.6 9.2 20.6 20.6v41.3c0 11.4-9.3 20.6-20.7 20.6",
    style: {
      fill: "#8ca4af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954 52.5H46C23.2 52.5 4.7 71 4.7 93.8v660.4c0 22.8 18.5 41.3 41.3 41.3h908c22.8 0 41.3-18.5 41.3-41.3V93.7c0-22.8-18.5-41.2-41.3-41.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 465.2v167.4h-60.7V423.9H356zM537.9 382.6v250h-60.6V341.4h30.1c.1 0 .1-.1.2-.1s.1.1.2.1h30.1zM719.8 258.8v373.8h-60.6V214.5h60.6z",
    style: {
      fill: "#ee751c"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDashboard);
export default ForwardRef;